import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 19 13"
    {...props}
  >
    <g fillRule="evenodd" transform="translate(1 1)">
      <path d="M9.636 9.426h-8.34S0 9.54 0 8.108V1.292S.094 0 1.27 0h12.334s1.648-.03 1.95 1.58c.303 1.611.553 3.037.553 3.037S17 4.996 17 6.148v2.313s.029.943-.927.943c-.957 0-6.437.022-6.437.022z" />
      <ellipse cx={3.091} cy={9.429} fill="#FFF" rx={1.545} ry={1.571} />
      <ellipse cx={13.909} cy={9.429} fill="#FFF" rx={1.545} ry={1.571} />
      <rect
        width={1.318}
        height={2.143}
        x={1.273}
        y={2.071}
        fill="#FFF"
        rx={0.659}
      />
      <rect
        width={1.318}
        height={2.143}
        x={4.364}
        y={2.071}
        fill="#FFF"
        rx={0.659}
      />
      <rect
        width={1.318}
        height={2.143}
        x={7.455}
        y={2.071}
        fill="#FFF"
        rx={0.659}
      />
      <path d="M15.455 1.571h-1.81s-.496-.008-.496.562v1.996s-.142.585.517.585h2.586M10.05 9.452V2.408s-.139-.837 1.102-.837c1.24 0 1.212.628 1.212.628v7.253m-1.159-.023V1.964" />
    </g>
  </svg>
);
const Memo = memo(SvgBus);
export default Memo;
